import fetchXhr from '../../fetchXhr';
import { buildCommonFetchOptions } from './UploaderCommon';

let S3MediaUploader = async (files, url, parameters, onProgress) => {
  if(files.length > 0 || files) {
    const file = files.length > 0 ? files[0] : files;
    const response = await fetch('/api/data/media', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
        'Content-Type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'media',
          attributes: Object.assign({ name: file.name.replace(/[^A-Za-z0-9_.-]/g, '-') }, parameters)
        }
      }),
      credentials: 'same-origin'
    })
    const data = await response.json();

    const fields = data.data.attributes.s3_post_fields;
    const url = data.data.attributes.s3_post_url;
    await S3Uploader(file, fields, url, onProgress)
    return data;
  }
}
//fields url is offline content create call
let S3Uploader = async (file, fields, url, onProgress) => {
  let formData = new FormData();

  let keysToFix = ['x_amz_signature', 'x_amz_date', 'x_amz_algorithm', 'x_amz_credential'];
  Object.keys(fields).forEach((key) => {
    if(keysToFix.includes(key)) {
      formData.append(key.split('_').join('-'), fields[key]);
    } else {
      formData.append(key, fields[key]);
    }
  });
  formData.append('file', file);

  return await fetchXhr(url, buildCommonFetchOptions(formData, onProgress));
}

export { S3MediaUploader, S3Uploader }
